import * as $ from 'jquery';

function handleError($field, message)
{
    // Fallback for selectpicker
    var $container = $field,
        $closestContainer = $field.closest('div.form-control');

    if ($closestContainer.length > 0) $container = $closestContainer;

    $container.addClass('is-invalid');
    $container.after( $('<div class="invalid-feedback">').html(message) );

    $container.one('click', function(e) {
        $container.next('div.invalid-feedback').remove();
        $container.removeClass('is-invalid');
    });
}

function createHiddenField(name, value)
{
    var $input = $('<input type="hidden">');
    $input.prop('name', name);
    $input.val(value);

    return $input;
}

export default (
    function()
    {
        $('.edition-order-table').each(function() {
            var $table = $(this);

            var $edition_ids = [];

            $table.find('.edition-order-add').on('click', function(e) {
                e.preventDefault();

                [].forEach.call(document.querySelectorAll('.invalid-feedback'),function(e){
                    e.parentNode.removeChild(e);
                });

                $table.on('click', 'button.edition-order-del-btn', function(e) {
                    e.preventDefault();
                    $(this).closest('tr').remove();
                });

                var $edition = $table.find('[name=editions]'),
                    $quantity = $table.find('[name=quantity]'),
                    row_count = $table.find('tbody > tr').length;

                // Validate
                var has_errors = false;
                if ($edition.val() == '')
                {
                    handleError($edition, 'This field is required');
                    has_errors = true;
                }
                if ($quantity.val() == '')
                {
                    handleError($quantity, 'This field is required');
                    has_errors = true;
                }

                if ($edition_ids.includes($edition.val())){
                    handleError($edition, 'You already chose this edition');
                    has_errors = true;
                }

                if (!has_errors)
                {
                    var data = {
                        edition_id: $edition.val(),
                        quantity: $quantity.val()
                    };

                    $edition_ids.push(data.edition_id);

                    var labels = {
                        edition_id: $edition.find('option:selected').text(),
                        quantity: $quantity.val()
                    };

                    var $row = $('<tr>'),
                        baseFieldName = 'editionlist[' + data.edition_id + ']';

                    $row.append( $('<td>').append(labels.edition_id) );
                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[quantity]', data.quantity) ).append(labels.quantity) );

                    var $delButton = $('<button class="btn btn-secondary edition-order-del-btn">').html('<i class="fa fa-trash-o">')

                    $row.append( $('<td>').append( $delButton ) );

                    $table.find('tbody').append($row);
                }

            });

        });
    }($)
);
